@switch (true) {
  @case (item.isRouterLink()) {
    <app-menu-item-router-link [item]="item">
      <ng-container [ngTemplateOutlet]="contentTemplate" />
    </app-menu-item-router-link>
  }
  @case (item.isLink()) {
    <app-menu-item-link [item]="item">
      <ng-container [ngTemplateOutlet]="contentTemplate" />
    </app-menu-item-link>
  }
  @case (item.isCommand()) {
    <app-menu-item-command [item]="item">
      <ng-container [ngTemplateOutlet]="contentTemplate" />
    </app-menu-item-command>
  }
  @case (item.isMore()) {
    <app-menu-item-more
      (toggleExpansionEvent)="handleToggleExpansionEvent($event)"
      [contentTemplateRef]="nestedContentTemplateRef"
      [item]="item">
      <ng-container [ngTemplateOutlet]="contentTemplate" />
    </app-menu-item-more>
  }
}

<ng-template #contentTemplate>
  @if (contentTemplateRef) {
    <ng-container
      [ngTemplateOutletContext]="{ item: item, expanded: expanded }"
      [ngTemplateOutlet]="contentTemplateRef" />
  } @else {
    <app-menu-item-content-default [item]="item" />
  }
</ng-template>
